import { render, staticRenderFns } from "./SelectCover.vue?vue&type=template&id=1ed94004&scoped=true"
import script from "./SelectCover.vue?vue&type=script&lang=js"
export * from "./SelectCover.vue?vue&type=script&lang=js"
import style0 from "./SelectCover.vue?vue&type=style&index=0&id=1ed94004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed94004",
  null
  
)

export default component.exports